







































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import valueTable from './components/valueTable.vue';
import investTable from './components/investTable.vue';
import exitTable from './components/exitTable.vue';
import moment from 'moment';

@Component({
  components: {
    valueTable,
    investTable,
    exitTable
  }
})
class Detail extends Vue {
  projectId: number | null = null;
  showMoreInfo: boolean = false;
  dateRange: string[] = ['20000101', '30000101'];

  mounted() {
    let { projectId } = this.$route.query;
    this.projectId = +projectId;
    this.fetchDetail();

    window.addEventListener('storage', this.refreshData);
  }

  destroyed() {
    window.removeEventListener('storage', this.refreshData);
  }

  get detail() {
    return this.$store.state.middlePageDetail.detail || {};
  }

  get auditDate() {
    let { auditDate } = this.$store.state.middlePageSlice.detail;
    return auditDate ? moment(auditDate).format('YYYY-MM-DD') : '暂无';
  }

  async fetchDetail() {
    try {
      let { projectId } = this;
      this.$store.commit('middlePageSlice/setProjectId', projectId);
      this.$store.commit('middlePageDetail/setProjectId', projectId);
      this.$store.dispatch('middlePageSlice/fetchSlice');
      this.$store.dispatch('middlePageDetail/fetchDetail');
    } catch (e) {
      console.log(e);
    }
  }

  switchShowMore() {
    this.showMoreInfo = !this.showMoreInfo;
  }

  refreshData(e) {
    if (e.key === 'handleSubmit') {
      this.fetchDetail();
    }
  }
  dateChange(endDate) {
    if (endDate) {
      endDate = endDate.format('YYYYMMDD');
    }
    this.$store.commit('middlePageSlice/dateRangeFilter', endDate);
  }
}

export default Detail;
